import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services'

export const getArticulosPanel = async (searchTerm, searchRam, searchRub, searchSubr,
  searchMar, searchDes, page, perPage) => {
  let queryParams = [];

  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
  }
  if (searchRam) {
    queryParams.push(`ramo_Id=${encodeURIComponent(searchRam)}`);
  }
  if (searchRub) {
    queryParams.push(`rubro_Id=${encodeURIComponent(searchRub)}`);
  }
  if (searchSubr) {
    queryParams.push(`subrubro_Id=${encodeURIComponent(searchSubr)}`);
  }
  if (searchMar) {
    queryParams.push(`marca_Id=${encodeURIComponent(searchMar)}`);
  }
  if (searchDes) {
    queryParams.push(`art_destacado=${encodeURIComponent(searchDes)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/articulos", queryString);
}

export const getArticulosExistenciaPanel = async (searchTerm,searchDepo, searchRam, searchRub, searchSubr,
  searchMar, searchDes, searchStock, page, perPage, selectOrderBy, selectOrder) => {
  let queryParams = [];

  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
  }
  if (searchDepo) {
    queryParams.push(`ade_depo_id=${encodeURIComponent(searchDepo)}`);
  }
  if (searchRam) {
    queryParams.push(`ramo_Id=${encodeURIComponent(searchRam)}`);
  }
  if (searchRub) {
    queryParams.push(`rubro_Id=${encodeURIComponent(searchRub)}`);
  }
  if (searchSubr) {
    queryParams.push(`subrubro_Id=${encodeURIComponent(searchSubr)}`);
  }
  if (searchMar) {
    queryParams.push(`marca_Id=${encodeURIComponent(searchMar)}`);
  }
  if (searchDes) {
    queryParams.push(`art_destacado=${encodeURIComponent(searchDes)}`);
  }
  if (searchStock) {
    queryParams.push(`tipo_stock=${encodeURIComponent(searchStock)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  if (selectOrderBy) {
    queryParams.push(`orderBy=${encodeURIComponent(selectOrderBy)}`);
  }
  if (selectOrder) {
    queryParams.push(`order=${encodeURIComponent(selectOrder)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/articulos/articulos_existencia", queryString);
}

export const getArticuloById = async (id) => {
  const res = await getData(`/articulos/${id}`)
  return res
}

export const postArticulo = async (body) => {
  const res = await postData('/articulos', body)
  return res
}

export const patchArticulo = async (id, body) => {
  const res = await patchData(`/articulos/${id}`, body)
  return res
}

export const deleteArticulo = async (id) => {
  const res = await deleteData(`/articulos/${id}`)
  return res
}

export const postArtCombo = async (body) => {
  const res = await postData('/combos', body)
  return res
}

export const patchArtCombo = async (id, body) => {
  const res = await patchData(`/combos/${id}`, body)
  return res
}

export const deleteArtCombo = async (id) => {
  const res = await deleteData(`/combos/${id}`)
  return res
}
